import * as React from "react";
import { Space, Tabs, Typography, Spin, notification } from "antd";
import Tooltip from "@funds/pages/MyFunds/parts/Tooltip";
import { connect } from "react-redux";
import {
  setAccessingFundsAgreementCreatedAt,
  setFundsData,
} from "@funds/features/action.funds";
import { TReducers } from "@features/reducers";
import MySharesPage from "../MySharesPage";

import * as style from "./PublicEquityPageStyles.module.scss";
import { CustodyBanner } from "@appComponents/CustodyBanner";

const mySharesTab = {
  label: "My Shares",
  key: "myShares",
  children: <MySharesPage />,
};

// TODO: Add transaction history in the future
// const transactionHistoryTab = {
//   label: (
//     <Link to="transactionHistory">
//       <div className={style.tabWrapper}>
//         <FundsSVG /> <span>Transaction history</span>
//       </div>
//     </Link>
//   ),
//   key: "transactionHistory",
//   children: <div />,
// }

type Props = {
  setFundsData: (investorId: number) => any;
  companyInvestorId: number | undefined;
  investorId: number | undefined;
};

const PublicEquityPage = ({
  setFundsData,
  companyInvestorId,
  investorId,
}: Props) => {
  const [loading, isLoading] = React.useState(true);
  const [activeTab, setActiveTab] = React.useState("myShares");

  React.useEffect(() => {
    const id = companyInvestorId || investorId;

    if (!id) throw new Error("ID is missing");

    setFundsData(id)
      .then(() => {
        isLoading(false);
      })
      .catch(() => {
        isLoading(false);
        notification.error({ message: "Something went wrong" });
      });
  }, []);

  return (
    <div className={style.publicEquityPage}>
      <Space align="center" className={style.publicEquityPageHeader}>
        <Space direction="vertical" className={style.headerTitleWrapper}>
          <Typography.Title level={2}>Public Shares</Typography.Title>
          <Tooltip
            title="Custody of shares"
            showArrow={false}
            tooltipMessage="Public Shares are held in custody with BF Global IB MU, a BF Securities Broker regulated in Mauritius. BF Global IB MU is licensed by the Mauritius Financial Services Commission (FSC) as a Full Service Dealer (Excluding Underwriting), enabling clients to custody, buy, sell, and trade Public Shares while holding a USD balance for share trading under custody."
          />
        </Space>
      </Space>

      <CustodyBanner />

      {loading ? (
        <Space
          align="center"
          style={{ justifyContent: "center", width: "100%", minHeight: 300 }}
        >
          <Spin size="large" />
        </Space>
      ) : (
        <Tabs
          defaultActiveKey={mySharesTab.key}
          activeKey={activeTab}
          items={[mySharesTab]}
          destroyInactiveTabPane
        />
      )}
    </div>
  );
};

const mapStateToProps = (store: TReducers) => ({
  investorId: store.userInfo.investor_id,
  companyInvestorId: store.companyReducer.companyDetails.investor_id,
});

const mapDispatchToProps = (dispatch: Function) => ({
  setFundsData: (investorId: number) => dispatch(setFundsData(investorId)),
  setAccessingFundsAgreementCreatedAt: () =>
    dispatch(setAccessingFundsAgreementCreatedAt()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicEquityPage);
